import { useState } from "react";

// npm packages
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";

// project imports
import { ProjectCard } from "./ProjectCard";

// config
import { projects } from "../config/projects";

import "animate.css";

import "./Projects.css";

export const Projects = () => {
  const { t } = useTranslation();

  const [data, setData] = useState(projects)

  const categoriesOptions = [
    { labelKey: "projects.filter.all", value: "all" },
    { labelKey: "projects.filter.reactjs", value: "reactjs" },
    { labelKey: "projects.filter.vuejs", value: "vuejs" },
    { labelKey: "projects.filter.design", value: "design" },
    { labelKey: "projects.filter.nodejs", value: "nodejs" },
    { labelKey: "projects.filter.email", value: "email" },
  ];

  const handleFilterByCategory = (category) => {
    if (category === "all") return setData(projects)

    const filteredData = projects.filter(({categories}) => categories.includes(category))

    setData(filteredData)
  }

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <div className="animate__animated animate__fadeIn">
              <h2>{t("projects.title")}</h2>
              <p>
                {t("projects.description")}
              </p>

              <Tab.Container
                id="projects-tabs"
                defaultActiveKey={categoriesOptions[0].value}
                onSelect={handleFilterByCategory}
              >
                <Nav
                  variant="pills"
                  className="nav-pills mb-5 justify-content-center align-items-center"
                  id="pills-tab"
                >
                  {categoriesOptions.map(({ labelKey, value }, index) => (
                    <Nav.Item key={index}>
                      <Nav.Link eventKey={value}>{t(labelKey)}</Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>

                <Tab.Content
                  id="slideInUp"
                  className="animate__animated animate__slideInUp"
                >
                  {categoriesOptions.map(({ value }, index) => (
                    <Tab.Pane eventKey={value} key={index}>
                    <Row className="gy-4">
                      {data.map((project, index) => {
                        return <ProjectCard key={index} {...project} />;
                      })}
                    </Row>
                  </Tab.Pane>
                  ))}
                </Tab.Content>
              </Tab.Container>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
